<template>
  <div class="row mb-4">
    <div class="col-md-12 pb-3">
      <h3 class="rel-title-menu">Proyectos</h3>
      <hr class="rel-hr-title" />
      <div class="container-fluid">
        <div class="row justify-content-between pl-4 pr-4">
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
               <i class="fab fa-react"></i>
            </div>
            <div class>
              <h5 class="p-3 mb-0">Vive la UAO</h5>
              
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Desarrollo de una aplicación web, en la que se administre el contenido de la aplicación móvil vive la UAO.</p>
              <p class="text-secondary pl-3 pr-3 m-0">En desarrolló</p>
              <!-- <a
                class="mb-1 p-2"
                href="https://github.com/ocralo/Instacol"
                target="_blank"
                rel="noopener noreferrer"
              >Ver repositorio</a> -->
            </div>
          </div>
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
               <i class="fab fa-java"></i>
            </div>
            <div class>
              <h5 class="p-3">Instacol</h5>
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Proyecto realizado en Java y MYSQL, en el que se hace una aproximación de la aplicación instagram.</p>
              <a
                class="mb-1 p-2"
                href="https://github.com/ocralo/Instacol"
                target="_blank"
                rel="noopener noreferrer"
              >Ver repositorio</a>
            </div>
          </div>
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
              <i class="fab fa-wordpress-simple"></i>
            </div>
            <div class>
              <h5 class="p-3">Pagina Web Semillero De Animación</h5>
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Proyecto realizado en Wordpress, en el que se desarrolló una página web para el semillero de animacion de la Universidad Autónoma de Occidente.</p>
              <a
                class="mb-1 p-2"
                href="https://www.uao.edu.co/seanima/"
                target="_blank"
                rel="noopener noreferrer"
              >Ver Pagina</a>
            </div>
          </div>
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
              <i class="fab fa-wordpress-simple"></i>
            </div>
            <div class>
              <h5 class="p-3">UAO LABS</h5>
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Proyecto realizado en Wordpress, en el que se desarrolló una página web para los laboratorios de la Universidad Autónoma de Occidente.</p>
              <a
                class="mb-1 p-2"
                href="https://sitios.uao.edu.co/labs/"
                target="_blank"
                rel="noopener noreferrer"
              >Ver Pagina</a>
            </div>
          </div>
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
              <i class="fab fa-vuejs"></i>
            </div>
            <div class>
              <h5 class="p-3">Fincasenalquiler.co</h5>
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Desarrollo una página web, con vista cliente y vista administrador, en la cual se puede observar en la vista cliente las diferentes fincas que se pueden alquilar y en la vista administrador se desarrolló un crud para los datos que se mostrarán en la vista cliente.</p>
              <a
                class="mb-1 p-2"
                href="http://fincasenalquiler.co/#/"
                target="_blank"
                rel="noopener noreferrer"
              >Ver Pagina</a>
            </div>
          </div>
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
              <i class="fab fa-react"></i>
            </div>
            <div class>
              <h5 class="p-3">IMUAO</h5>
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Proyecto que busca visualizar los perfiles y proyectos de los estudiantes de ingeniería multimedia de la Universidad Autónoma de Occidente.</p>
              <a
                class="mb-1 p-2"
                href="https://github.com/ocralo/imuao"
                target="_blank"
                rel="noopener noreferrer"
              >Ver repositorio</a>
            </div>
          </div>
          <div
            class="col-md-5 rel-bg-content-2 mt-4 d-flex flex-md-wrap flex-lg-nowrap justify-content-around pt-3 pb-4"
          >
            <div class="rel-tex-icon-proyect pr-2">
              <i class="fab fa-vuejs"></i>
            </div>
            <div class>
              <h5 class="p-3">Chatbot UAO Virtual</h5>
              <p
                class="rel-paragraph-proyect text-white-50 text-justify"
              >Desarrollo de un Chatbot que facilite el manejo de la plataforma UAO Virtual y solucione las dudas que tengan sobre el manejo de la plataforma</p>
              <a
                href="https:pcampus.uaovirtual.edu.co/login/index.php"
                target="_blank"
                rel="noopener noreferrer"
              >Ver Pagina</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {}
};
</script>

<style>
</style>